import React from 'react'
import { Container, FilledButton, OutlinedButton } from '@jsluna/react'
import { PropTypes } from 'prop-types'
 
const DuplicateYCodeModal = props => (
  <div className={props.modalAlertOpen ? 'ln-c-modal js-modal is-open' : 'ln-c-modal js-modal'}>
    <div className="ln-u-fill-height">
      <div
        className="ln-c-modal__body js-modal-body ln-c-modal-alert__body-30perc"
        id="modalAlert"
        tabIndex="0"
        role="dialog"
        aria-labelledby="modalAlertTitle"
      >
        <Container className="ln-u-push-left ln-u-push-right">
          {
          <div>
            <h3>{props.duplicateModalText}</h3>
            {}
            <div className="ln-u-push-bottom">
               
            </div>
            <div className="ln-u-push-bottom">
              <div className="ln-o-grid ln-o-grid--matrix">
                <div className="ln-o-grid__item ln-u-1/4@sm ln-u-1/2@xs ln-u-1/1">
                  <OutlinedButton
                    className="ln-c-button ln-c-button--large ln-c-button--secondary ln-c-button--full"
                    role="button"
                    onClick={props.modalCancel}
                  >Cancel
                  </OutlinedButton>
                </div>
                <div className="ln-o-grid__item ln-u-1/4@sm ln-u-1/2@xs ln-u-1/1">
                  <FilledButton
                    className="ln-c-button ln-c-button--large ln-c-button--primary ln-c-button--full"
                    onClick={props.modalConfirm}
                 
                  >Confirm
                  </FilledButton>
                </div>
              </div>
            </div>
          </div>
          }
        </Container>
      </div>
    </div>
  </div>
)
 
DuplicateYCodeModal.propTypes = {
  modalAlertOpen: PropTypes.bool.isRequired,
  modalConfirm: PropTypes.func.isRequired,
  modalCancel: PropTypes.func,
 
  duplicateModalText: PropTypes.string.isRequired,
 
}
 
export default DuplicateYCodeModal


// WEBPACK FOOTER //
// ./src/components/DuplicateYCodeModal.jsx